import { compose } from '@bem-react/core';
import {
    Link as LinkPresenter,
    withThemeBlack
} from '@yandex-lego/components/Link/desktop';

const Link = compose(withThemeBlack)(LinkPresenter);

export default Link;
